import { toast } from 'react-toastify'

import DI from '../../app/di'
import { Descriptive, FutureResult } from '../../interfaces/base'
import { Project, ProjectId } from '../../interfaces/entities/project'
import { GetClient, GetClients } from '../../interfaces/services/clients'
import {
  GetProject,
  IProjectService,
  SaveProject,
  SearchProjects,
} from '../../interfaces/services/projects'
import { IStringAnyMap } from '../../types/map'
import { translateWithUserLocale } from '../../utils/i18n'
import { ListenerApi, on } from '../listener'
import * as actions from './actions'

export const Commands: () => {
  save: SaveProject
  update: SaveProject
  getClients: GetClients
  getClient: GetClient
  getProjects: SearchProjects
  getProject: GetProject
  doRedirectToProject: (projectId: ProjectId) => any
  doProjectAction: (
    action: Descriptive,
    project: Project,
    options: IStringAnyMap,
  ) => FutureResult<Project>
} = () => {
  const projectService = DI.get('ProjectService') as IProjectService

  return {
    getClients: () => {
      return projectService.getClients()
    },
    getClient: (contactId, advertiserContacts, projectId) => {
      return projectService.getClient(contactId, advertiserContacts, projectId)
    },
    getProjects: (filter, paging) => {
      return projectService.searchProjects(filter, paging)
    },
    getProject: (projectId) => {
      return projectService.getProject(projectId)
    },
    save: async (project) => {
      const result = await projectService.saveProject(project)

      if (result.type === 'success' && result.payload.created) {
        const history = DI.get('history')
        setTimeout(() => {
          history.push(`/project/${result.payload.project.id}`)
        }, 200)
      }

      return result
    },
    update: (project) => {
      return projectService.saveProject(project)
    },
    doProjectAction: (action, project, options) => {
      return projectService.doProjectAction(action, project, options)
    },
    doRedirectToProject: (projectId: ProjectId) => {
      const history = DI.get('history')
      const url = `/project/${projectId}`
      history.push(url)
    },
  }
}

on(actions.getProjects, async (action, api) => {
  // The filter/pagination the reducer was called with, i.e. what the command
  // arguments used to close over.
  const state = api.getOriginalState().projects

  api.dispatch(
    actions.getProjectsCompleted(
      await Commands().getProjects(
        action.payload === null ? state.filter : action.payload,
        state.tablePagination,
      ),
    ),
  )
})

on(actions.filterUpdated, (action, api) => {
  api.dispatch(actions.getProjects(action.payload))
})

on(actions.saveProject, async (action, api) => {
  api.dispatch(
    actions.saveProjectCompleted(await Commands().save(action.payload)),
  )
})

on(actions.saveProjectCompleted, (action, api) => {
  if (action.payload.type === 'error') {
    return
  }

  if (action.payload.payload.created) {
    Commands().doRedirectToProject(action.payload.payload.project.id)
  } else {
    api.dispatch(actions.getProjects(null))
  }
})

on(actions.doProjectAction, async (action, api) => {
  api.dispatch(
    actions.doProjectActionComplete(
      await Commands().doProjectAction(
        action.payload.action,
        action.payload.project,
        action.payload.options as any,
      ),
    ),
  )
})

on(actions.doProjectActionComplete, (action, api) => {
  const result = api.getOriginalState().projects.result

  if (action.payload.type !== 'success') {
    toast.error(action.payload.payload.message, { autoClose: false })
    return
  }

  const newProject = action.payload.payload

  toast.success(
    newProject.message
      ? newProject.message
      : translateWithUserLocale('success_message.change_status'),
  )

  if (result != null) {
    api.dispatch(actions.getProjects(null))
  }
})

const reloadProjects = (_action: unknown, api: ListenerApi) => {
  api.dispatch(actions.getProjects(null))
}

on(actions.onCurrentPageChange, reloadProjects)
on(actions.onPageSizeChange, reloadProjects)
on(actions.onSortingChange, reloadProjects)
